import { Component, Input, OnInit } from '@angular/core';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { AppConstants } from 'src/app/core/constants';

@Component({
  selector: 'app-image-carousel',
  templateUrl: './image-carousel.component.html',
  styleUrls: ['./image-carousel.component.scss',],
})
export class ImageCarouselComponent implements OnInit {

  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  @Input() images: string[] = [];
  @Input() isDetail: boolean = false;

  filteredImages: string[] = [];

  currentSlide: number = AppConstants.ZERO;

  constructor() { }

  ngOnInit(): void {
    this.nextSlide(this.currentSlide);
  }

  nextSlide(x: number) {
    this.currentSlide = (this.currentSlide + this.images.length + x) % this.images.length;
  }

  slideTo(slideNum: number) {
    this.currentSlide = slideNum;
  }

}
